import { Button } from "@admin/components/atoms/Button";
import { FoodControlPointInstanceDto } from "@enos-monorepo/lib";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { DeleteOverduesModal } from "./Modals/DeleteOverduesModal";

interface DeleteOverduesProps {
  selectedInstances: FoodControlPointInstanceDto[];
}

export function DeleteOverdues({ selectedInstances }: DeleteOverduesProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="  bg-white rounded-xl h-fit">
      <div className="flex flex-row gap-10 items-center border-b-[1px] border-b-gray-300">
        <h1 className="card-title p-5">
          {t("food.Delete Selected Overdue Controls")}
        </h1>
        <i className="ki-outline ki-information-2 text-2xl"></i>
      </div>

      <div className="px-7.5 py-2.5 border-b-[1px] border-b-gray-300">
        {t("food.Delete Overdue Text")}
      </div>

      <div className="py-2.5 pr-7.5 float-end">
        <Button
          onClick={() => setIsOpen(true)}
          property="danger"
          disabled={selectedInstances.length === 0}
        >
          {t("food.Delete Overdue Controls")}
        </Button>
      </div>

      <DeleteOverduesModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        selectedInstances={selectedInstances}
      />
    </div>
  );
}
